import { render, staticRenderFns } from "./FileModal.vue?vue&type=template&id=0ef33e14&scoped=true&"
import script from "./FileModal.vue?vue&type=script&lang=js&"
export * from "./FileModal.vue?vue&type=script&lang=js&"
import style0 from "./FileModal.vue?vue&type=style&index=0&id=0ef33e14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef33e14",
  null
  
)

export default component.exports